import { createContext } from 'react'

/** Extensible string union — known reasons get autocomplete, arbitrary strings are accepted */
export type ReadOnlyReason = 'archived' | 'public' | 'manual' | (string & {})

export interface ReadOnlyContextValue {
  /** Whether the UI is currently in read-only mode (derived: reasons.size > 0) */
  isReadOnly: boolean
  /** @deprecated Use readOnlyReasons instead. Returns the first active reason or null. */
  readOnlyReason: ReadOnlyReason | null
  /** The set of active reasons why read-only is on (multiple can be active simultaneously) */
  readOnlyReasons: Set<ReadOnlyReason>
  /** Activate read-only for a given reason */
  activateReadOnly: (reason: ReadOnlyReason) => void
  /** Deactivate read-only for a given reason */
  deactivateReadOnly: (reason: ReadOnlyReason) => void
}

const noop = (): void => {}

const defaultReadOnlyContext: ReadOnlyContextValue = {
  isReadOnly: false,
  readOnlyReason: null,
  readOnlyReasons: new Set(),
  activateReadOnly: noop,
  deactivateReadOnly: noop,
}

export const ReadOnlyContext = createContext<ReadOnlyContextValue>(defaultReadOnlyContext)
